import { Icon, Icons } from "./Icon"

interface OverlayScrollFooterProps {
  isAtBottom: boolean;
  showScrollButton: boolean;
  handleScrollMore: () => void;
  readMoreLabel: string;
}

export function OverlayScrollFooter({ isAtBottom, showScrollButton, handleScrollMore, readMoreLabel }: OverlayScrollFooterProps) {
  return (
    <div className={`Overlay-footer ${isAtBottom ? "at-bottom" : ""}`}>
      {showScrollButton && (
        <button className="scroll-more-button" onClick={handleScrollMore}>
          <span>{readMoreLabel}</span>
          <Icon icon={Icons.ArrowDown} />
        </button>
      )}
    </div>
  );
}
